import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import Popup from 'reactjs-popup'
import Icon from 'srcReact/components/icons/Icon'
import { useTranslation } from 'react-i18next'
import ManageMembers from 'srcReact/MessengerPage/components/ManageMembers'
import { useDispatch, useSelector } from 'react-redux'
import RenameConversation from 'srcReact/MessengerPage/components/RenameConversation'
import LeaveConversation from 'srcReact/MessengerPage/components/LeaveConversation'
import MemberImages from 'srcReact/components/common2/MemberImages'
import { messengerActions } from 'srcReact/MessengerPage'
import options from './options'
import DeleteConversation from 'srcReact/MessengerPage/components/DeleteConversation'
import MuteConversation from '../MuteConversation'
import HideConversation from '../HideConversation'
import UnmuteConversation from '../UnmuteConversation'
import ResumeConversation from '../ResumeConversation'
import Modal from 'srcReact/components/common2/Modal'
import ChooseAdminOnLeave from '../ChooseAdminOnLeave'
import history from 'srcReact/helpers/history'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import MemberNames from 'srcReact/components/common2/MemberNames'
import ReactMenu from 'srcReact/components/common2/ReactMenu'
import { isNativeIOS } from 'srcReact/helpers/utils'
import BackNavigation from 'srcReact/components/common2/BackNavigation'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import IconButton from 'srcReact/components/common2/IconButton'

const HeaderMobile = ({
  fromProfile,
  fromFeed,
  fromLightProfile,
  fromQuickMessenger,
  closeMessengerPopup,
  closeLightProfile,
  setConversationId,
  closeQuickMessenger
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    common: { isMobile, isTablet, isNative, isDesktop },
    login: { user: loggedInUser },
    messenger: { openedConversation, openManageMemberIfSoleAdmin, openedFromLightProfile },
    lightProfile: { userInput }
  } = useSelector((state) => state)
  const [modalName, setModalName] = useState('')
  const [isSoleAdmin, setIsSoleAdmin] = useState(false)
  const [chatOptions, setChatOptions] = useState([])

  useEffect(() => {
    //set chat options on conversation change
    setChatOptions(options(handleOpenPopin, openedConversation, t))

    if (openedConversation && openedConversation.conversation.user_is_conversation_admin === 0) {
      return
    }
    if (openedConversation) {
      if (openedConversation.conversation.user_is_conversation_admin === 0) {
        return
      }
      const { active_users: activeUsers } = openedConversation
      const isAnotherAdminExists = activeUsers.some((u) => u.is_conversation_admin === 1 && u.id !== loggedInUser.id)

      if (isAnotherAdminExists) {
        setIsSoleAdmin(false)
        return
      }
      setIsSoleAdmin(true)
    }
  }, [openedConversation])
  // useEffect(() => {
  //   if (openManageMemberIfSoleAdmin) {
  //     setModalName('manage-members')
  //     //handleOpenPopin('manage-members')
  //   }
  // }, [openManageMemberIfSoleAdmin])

  const handleOpenPopin = (name) => {
    setModalName(name)
    if (name === 'leave-conversation' && isSoleAdmin) {
      setModalName('select-admin-on-leave')
    } else {
      setModalName(name)
    }
    // dispatch(commonActions.openPopin(name))
  }

  const showUserModal = (user) => {
    const lp = new LightProfileProto()
    lp.userId = user.id
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }
  const showSidebar = () => {
    dispatch(messengerActions.showSidebar(true))
    dispatch(messengerActions.showMainContent(false))
    // dispatch(messengerActions.setOpenConversation(null))
    // dispatch(messengerActions.resetConversationSearchText())
    // dispatch(messengerActions.setUserAllowedForNotificationMessage())
    if (fromQuickMessenger && setConversationId) {
      setConversationId(0)
    } else {
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams) {
        history.replace('/0/messenger')
      }
    }
  }
  const closeModal = () => {
    setModalName('')
  }
  const isGroupConv = openedConversation?.conversation?.is_group_conversation == 1

  return (
    <React.Fragment>
      <div
        className={`${styles.innerHeaderContainer} ${fromLightProfile && styles.lpInnerHeaderContainer} ${
          isNativeIOS() && styles.isNativeIOS
        }`}>
        {(isMobile || isTablet || (isDesktop && fromQuickMessenger)) && !fromLightProfile && !fromFeed ? (
          <BackNavigation
            theme={fromQuickMessenger ? 'lightblue' : 'white'}
            className={styles.backButton}
            customHandleBack={showSidebar}
          />
        ) : null}
        {fromLightProfile && !isGroupConv && !fromProfile && (
          <BackNavigation
            theme={isMobile || isTablet ? 'white' : 'lightblue'}
            className={styles.backLightProfile}
            customHandleBack={() => {
              if (closeMessengerPopup) {
                closeMessengerPopup()
              }
            }}
          />
        )}
        {openedConversation && openedConversation.active_users && openedConversation.active_users.length > 0 ? (
          <MemberImages
            imgSizeSingle='small'
            imgSizeDouble='xsmall'
            imgSizeMore={fromQuickMessenger ? 'tiny' : 'xsmall'}
            imgSingleCss={styles.oneImageCSS}
            imgDoubleCss={styles.twoImageCSS}
            imgMoreCss={styles.moreImageCSS}
            members={openedConversation.active_users.filter((u) => !u.is_logged_user)}
            displayCount={3}
            onClick={showUserModal}
            conversationName={openedConversation.conversation.user_conversation_name}
            handleOpenPopin={handleOpenPopin}
          />
        ) : null}
        {openedConversation && openedConversation.active_users && openedConversation.active_users.length > 0 ? (
          <div className={`${styles.fullName} ${isGroupConv && styles.isGroupConv}`}>
            <p>
              <MemberNames
                id={openedConversation.conversation.id}
                members={openedConversation.active_users.filter((u) => !u.is_logged_user)}
                conversationName={openedConversation.conversation.user_conversation_name}
                isMobile={isMobile || isNative}
                isTablet={isTablet}
              />
            </p>
            {isGroupConv && (
              <span onClick={() => handleOpenPopin('manage-members')}>
                {t('messenger.header.peopleCount', { count: openedConversation.active_users.length })}
              </span>
            )}
          </div>
        ) : null}
        {fromQuickMessenger ? (
          <IconButton
            iconName='chevron-down24'
            iconSize='large24'
            className={styles.btnCloseQckMessenger}
            onClick={closeQuickMessenger}
          />
        ) : (
          chatOptions?.length > 0 &&
          !openedFromLightProfile &&
          !fromLightProfile &&
          !fromFeed && (
            <div className={styles.options}>
              <ReactMenu
                ariaLabel={t('messenger.header.conversationOptions')}
                options={chatOptions}
                menuButtonCSS={styles.optionsButton}
                menuItemCSS={styles.optionsMenuItem}
              />
            </div>
          )
        )}
        {(fromLightProfile || fromFeed) && (
          <button
            className={`${styles.closeButton} ${styles.lpCloseButton}`}
            type='button'
            onClick={() => {
              if (closeLightProfile && fromLightProfile) {
                closeLightProfile()
              }
              if (closeMessengerPopup && fromFeed) {
                closeMessengerPopup()
              }
            }}>
            <Icon name='close24' size='large24' />
          </button>
        )}
      </div>
      <Popup
        modal
        nested
        open={modalName === 'manage-members'}
        onClose={closeModal}
        position='top center'
        overlayStyle={{ background: 'rgba(54, 73, 88, 0.4)', padding: '2rem 0 0', overflowY: 'scroll' }}
        contentStyle={{
          width: '95%',
          maxWidth: '500px',
          padding: '3rem 1rem',
          borderRadius: '22px',
          boxShadow: '5px 2px 10px 0 rgba(14, 11, 40, 0.15)',
          background: 'white',
          border: 'none',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '0.625rem'
        }}>
        <ManageMembers closeModal={closeModal} />
        <button type='button' className={styles.closeIcon} onClick={closeModal}>
          <Icon name='close24' />
        </button>
      </Popup>
      <Modal isOpen={modalName === 'rename-conversation'} handleClose={closeModal}>
        <RenameConversation
          conversationId={openedConversation && openedConversation.conversation.id}
          closeModal={closeModal}
        />
      </Modal>
      <Modal
        isOpen={modalName === 'leave-conversation'}
        handleClose={closeModal}
        customContentStyle={!isMobile && !isTablet ? { maxWidth: '40.6rem', width: '95%' } : null}>
        <LeaveConversation closeModal={closeModal} />
      </Modal>
      <Modal isOpen={modalName === 'select-admin-on-leave'} handleClose={closeModal}>
        <ChooseAdminOnLeave closeModal={closeModal} />
      </Modal>

      <Modal isOpen={modalName === 'delete-conversation'} handleClose={closeModal}>
        <DeleteConversation closeModal={closeModal} />
      </Modal>
      <Modal isOpen={modalName === 'resume-conversation'} handleClose={closeModal}>
        <ResumeConversation closeModal={closeModal} />
      </Modal>
      <Modal isOpen={modalName === 'mute-conversation'} handleClose={closeModal}>
        <MuteConversation closeModal={closeModal} />
      </Modal>
      <Modal isOpen={modalName === 'unmute-conversation'} handleClose={closeModal}>
        <UnmuteConversation closeModal={closeModal} />
      </Modal>
      <Modal isOpen={modalName === 'hide-conversation'} handleClose={closeModal}>
        <HideConversation closeModal={closeModal} />
      </Modal>
    </React.Fragment>
  )
}

export default HeaderMobile
